import { isNil } from 'lodash';

import { DeviceType } from '@/constants/deviceTypeEnum';

export const getFlowTooltip = (compressor, t) => {
  return isNil(compressor.estimatedFlowM3Min) ? t('Sensor based') : t('kW based calculation');
};

export const getInverterSpeedValue = (compressor, tvalue) => {
  let variableSpeed;
  switch (compressor.deviceType) {
    case DeviceType.VariableSpeedDrive:
    case DeviceType.VariableSpeedDriveAndPowerSensor:
      if (
        (isNil(compressor.inverterSpeedRPM) && isNil(compressor.estimatedInverterSpeedRPM)) ||
        isNil(compressor.maxInverterSpeedRPM) ||
        compressor.maxInverterSpeedRPM === 0
      )
        return undefined;

      variableSpeed =
        ((compressor.estimatedInverterSpeedRPM ? compressor.estimatedInverterSpeedRPM : compressor.inverterSpeedRPM) /
          compressor.maxInverterSpeedRPM) *
        100;
      return tvalue(variableSpeed, 'rpm');

    default:
      return compressor.inverterSpeedRPM;
  }
};

export const getInverterSpeedTooltipContent = (compressor, tvalue, t) => {
  switch (compressor.deviceType) {
    case DeviceType.VariableSpeedDrive:
    case DeviceType.VariableSpeedDriveAndPowerSensor:
      if (!getInverterSpeedValue(compressor, tvalue)) return null;
      return compressor.estimatedInverterSpeedRPM
        ? t('kW based Calculation')
        : `${tvalue(compressor.inverterSpeedRPM, 'rpm')} ${t('RPM')} / ${tvalue(
            compressor.maxInverterSpeedRPM,
            'rpm',
          )} ${t('RPM')}`;

    default:
      return null;
  }
};
